export default __webpack_public_path__ + "static/media/info-tooltip2.85445129.svg";